<script lang="jsx">
import Base from "../config.vue";
import EditSimple from "./edit-simple.vue";

export default {
  render() {
    if (this.$context.is.edit && this.$context.is.simplify) {
      return <EditSimple />;
    }
    return <Base />;
  },
};
</script>
